module.exports = window.DOMPurify || (window.DOMPurify = require('dompurify').default || require('dompurify'));


// WEBPACK FOOTER //
// ./~/isomorphic-dompurify/browser.js